export default __webpack_public_path__ + "static/schema-43ec548b8debee29f139357659c6cc86.png";